/** @param {Element} element */
function GoogleMap(element) {
  this.element = element;
  this.map = undefined;
  this.geocoder = undefined;
  this.markers = [];

  this.addMarker = this.addMarker.bind(this);

  this.init();
}

GoogleMap.prototype.init = function () {
  var element = this.element;
  this.map = new google.maps.Map(element, {
    center: {
      lat: 54.25,
      lng: -4.5
    },
    zoom: 6
  });

  this.geocoder = new google.maps.Geocoder();
};

GoogleMap.prototype.addMarker = function (location) {
  var infowindow = new google.maps.InfoWindow({
    content:
      '<div id="content">' +
      '<div id="siteNotice"></div>' +
      '<h1 id="firstHeading" class="firstHeading">' +
      location.title +
      '</h1>' +
      '<div id="bodyContent">' +
      '<p>' +
      location.address.address1 +
      ', ' +
      location.address.address2 +
      ', ' +
      location.address.town +
      ', ' +
      location.address.county +
      '</p>' +
      '</div>' +
      '</div>'
  });
  var marker = new google.maps.Marker({
    position: location.position,
    title: location.title,
    map: this.map
  });

  marker.addListener('click', () => {
    this.map.panTo(marker.getPosition());

    var $el = document.querySelector(
      '[data-stockist-finder-map-lat="' +
        marker.position.lat() +
        '"][data-stockist-finder-map-lng="' +
        marker.position.lng() +
        '"]'
    );
    $el.parentElement.scrollIntoView(true, {
      behaviour: 'smooth'
    });

    infowindow.open(this.map, marker);
  });

  this.markers.push(marker);

  return marker;
};

GoogleMap.prototype.addMarkers = function (locations) {
  var _this = this;
  var bounds = new google.maps.LatLngBounds();

  locations.forEach(function (location) {
    var marker = _this.addMarker(location);

    bounds.extend(
      new google.maps.LatLng(marker.position.lat(), marker.position.lng())
    );
  });

  // Auto-centre and zoom
  this.map.fitBounds(bounds);
  this.map.panToBounds(bounds);
};

GoogleMap.prototype.clearMarkers = function () {
  this.markers.forEach(function (marker) {
    marker.setMap(null);
  });

  this.markers = [];
};

GoogleMap.prototype.setCentre = function (location) {
  this.map.panTo(location);
};

GoogleMap.prototype.setZoom = function (value) {
  this.map.setZoom(value);
};

// Helper to access route parameters
window.Route = (function () {
  // A cache for our parameters so that we don't have to run the regex each
  // time we want to access a parameter.
  var params = {};

  // Decode the given string.
  var decode = function (string) {
    return decodeURIComponent(string.replace(/\+/g, ' '));
  };

  // Parse the query string
  (window.onpopstate = function () {
    var match,
      url = window.location.href,
      search = /([^&=]+)=?([^&]*)/g,
      query = window.location.search.substring(1);

    while ((match = search.exec(query))) {
      params[decode(match[1])] = decode(match[2]);
    }
  })();

  // Return the API object
  return {
    // Return a parameter by name.
    param: function (name) {
      return params[name] || null;
    },

    // Return all parameters
    all: function () {
      return params;
    }
  };
})();

/**
 * @typedef {{
 *      Name: string;
 *      Add1: string;
 *      Add2: string;
 *      Town: string;
 *      County: string;
 *      PostCode: string;
 *      Tel: string;
 *      Lat: string;
 *      Long: string;
 *      Distance: string;
 * }} Stockist
 */

/** @param {Element} element */
function StockistFinder(element) {
  this.element = element;
  this.stockistsList = document.querySelector('[data-stockist-finder-results]');
  this.stockistsListHeader = document.querySelector(
    '[data-stockist-finder-results-header]'
  );
  this.stockistsListClose = document.querySelector(
    '[data-stockist-finder-results-close]'
  );
  this.resultTemplate = document.querySelector(
    '[data-stockist-finder-template="result"]'
  ).innerHTML;
  this.errorTemplate = document.querySelector(
    '[data-stockist-finder-template="error"]'
  ).innerHTML;
  this.lang = JSON.parse(
    document.querySelector('[data-stockist-lang]').innerHTML
  );
  this.map = undefined;
  this.optionalInputs = ['collection', 'sku'];
  this.classes = {
    stockistsList: {
      active: 'stockist-finder__results__header--active'
    }
  };

  this.handleSubmit = this.handleSubmit.bind(this);
  this.element.addEventListener('submit', this.handleSubmit);

  this.closeStockistsList = this.closeStockistsList.bind(this);
  this.stockistsListClose.addEventListener('click', this.closeStockistsList);

  this.renderMap(document.querySelector('[data-stockist-finder-map]'));
  this.setInputValuesFromUrl();
}

StockistFinder.prototype.handleSubmit = function (event) {
  if (!this.element.postcode.value || this.element.postcode.value.length < 1) {
    return this.renderError('invalid_location');
  }

  // Build the URL query
  var query = '?';
  if (this.getSku()) {
    query += 'sku=' + this.getSku();
  } else if (this.getCollection()) {
    query += 'collection=' + this.getCollection();
  }
  if (query !== '?') {
    query += '&';
  }
  query += 'postcode=' + this.element.postcode.value;

  // Update the URL with the new query parameters.
  history.pushState(null, null, query);

  this.getGeolocation(this.element.postcode.value);

  event && event.preventDefault();
};

StockistFinder.prototype.getGeolocation = function (address, callback) {
  var _this = this;

  function requiredDataIsAvailable() {
    return address && address.length > 0;
  }

  if (!requiredDataIsAvailable()) {
    return this.renderError('invalid_location');
  }

  this.map.geocoder.geocode(
    {
      address: address
    },
    function (response) {
      if (response.length < 1) {
        return _this.renderError('invalid_location');
      }

      _this.getStockists(
        address,
        response[0].geometry.location.lat(),
        response[0].geometry.location.lng()
      );
    }
  );
};

StockistFinder.prototype.getStockists = function (address, lat, lng) {
  var _this = this;

  var request = this.buildStockistsQuery(lat, lng);

  const buttonElement = document.getElementById('stockist_finder_submit_button');
  if(buttonElement) buttonElement.disabled = true;

  axios
    .post(
      'https://api.woodlodge.co.uk/graphql',
      JSON.stringify({
        query: `
            query GetStockists($coordinates: Coordinates!, $sku: String, $category: String) {
                stockists(
                    first: 10, 
                    radius: 20, 
                    coordinates: $coordinates,
                    productId: $sku,
                    category: $category
                ) {
                    edges {
                        distance
                        cursor
                        node {
                            id
                            name
                            referenceId
                            lastOrdered
                            phone
                            address {
                                id
                                address1
                                address2
                                town
                                county
                                latitude
                                longitude
                                postCode
                            }
                        }
                    }
                }
            }
        `,
        variables: {
          coordinates: {
            latitude: request.parameters.coords.lat,
            longitude: request.parameters.coords.lon
          },
          category: request.parameters.category,
          sku: request.parameters.sku
        }
      }),
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Basic d2ViLXRyYWRlLWZyb250ZW5kOmZ3VmViVmdmRFAzTnIzTjg==='
        }
      }
    )
    .then(function (response) {
      if(buttonElement) buttonElement.disabled = false;
      
      const results = response?.data?.data?.stockists?.edges || [];
      if(response?.data?.errors) throw new Error(response.data.errors[0].message)

      if (request.parameters.sku)
        if (ga)
          ga(
            'send',
            'event',
            'Find Retailers',
            'by SKU',
            address.toUpperCase(),
            { metric1: results.length, dimension1: request.parameters.sku }
          );
        else if (request.parameters.category)
          if (ga)
            ga(
              'send',
              'event',
              'Find Retailers',
              'by Collection',
              address.toUpperCase(),
              {
                metric1: results.length,
                dimension2: request.parameters.category
              }
            );

      _this.buildStockistsList(results);
    })
    .catch(function (error) {
      if (error === 'No responses for given location') {
        return _this.renderError('invalid_location');
      }

      console.error('Find a stockist error:', error.message, {
        request,
        error
      });
      return _this.renderError('unexpected_error');
    });
};

let stockistOnload = true;
StockistFinder.prototype.getSku = function () {
  if (stockistOnload && Route.param('sku')) {
    return Route.param('sku');
  }
  stockistOnload = false;

  const element = document.querySelector('[data-product-sku]');

  if (element) {
    return element.innerText;
  }
};

StockistFinder.prototype.getCollection = function () {
  var element = this.element.collection;

  if (element) {
    return element.value;
  }
};

StockistFinder.prototype.buildStockistsQuery = function (lat, lng) {
  var request = {
    parameters: {
      coords: {
        lat: lat,
        lon: lng
      }
    }
  };

  if (this.getSku()) {
    request.parameters.sku = this.getSku();
  } else if (this.getCollection()) {
    request.parameters.category = this.getCollection();
  }

  return request;
};

StockistFinder.prototype.buildStockistsList = function (data) {
  var _this = this;

  if (data.length === 0) return this.renderError('no_results_found');

  this.stockistsList.innerHTML = data
    .map(function (stockist) {
      return _this.resultTemplate
        .replace(/{{ stockist.name }}/g, stockist.node.name)
        .replace(/{{ stockist.url }}/g, _this.buildUrl())
        .replace(/{{ stockist.distance }}/g, stockist.distance)
        .replace(
          /{{ stockist.address }}/g,
          [
            stockist.node.address.address1,
            stockist.node.address.address2,
            stockist.node.address.town,
            stockist.node.address.county
          ]
            .filter(Boolean)
            .join(', ')
        )
        .replace(/{{ stockist.lat }}/g, stockist.node.address.latitude)
        .replace(/{{ stockist.lng }}/g, stockist.node.address.longitude);
    })
    .join('');

  this.stockistsListHeader.classList.add(this.classes.stockistsList.active);

  this.populateMapWithStockists(data);

  Array.prototype.forEach.call(
    this.getResultElements(),
    function (resultElement) {
      resultElement
        .querySelector('[data-stockist-finder-map-lat]')
        .addEventListener('click', function (event) {
          if (_this.map === undefined) return;

          _this.map.setCentre({
            lat: parseFloat(event.currentTarget.dataset.stockistFinderMapLat),
            lng: parseFloat(event.currentTarget.dataset.stockistFinderMapLng)
          });
          _this.map.setZoom(12);

          if (window.scrollY > _this.element.offsetTop) {
            window.scrollTo(_this.element.offsetLeft, _this.element.offsetTop);
          }

          // If we are already on the page we do not want to force a page refresh.
          if (event.currentTarget.href.includes(window.location.pathname)) {
            event.preventDefault();
          }
        });
    }
  );

  this.resizeParent();
};

StockistFinder.prototype.buildUrl = function (url) {
  var queryDelimiter = '?';
  if (this.element.dataset.stockistUrl.includes('?')) {
    queryDelimiter = '&';
  }
  return (
    this.element.dataset.stockistUrl +
    queryDelimiter +
    'postcode=' +
    this.element.postcode.value
  );
};

StockistFinder.prototype.renderError = function (error) {
  this.stockistsList.innerHTML = this.errorTemplate
    .replace(/{{ error }}/g, this.lang[error])
    .replace(
      /{{ contact_customer_services }}/g,
      this.lang.contact_customer_services
    );

  this.resizeParent();
};

StockistFinder.prototype.resizeParent = function () {
  var productInfoElement = document.querySelector(
    '.product-block-list__item--info .card--sticky'
  );

  if (productInfoElement) {
    document.querySelector('.product-block-list__wrapper').style.minHeight =
      productInfoElement.clientHeight + 'px';
  }
};

StockistFinder.prototype.populateMapWithStockists = function (stockists) {
  this.map.clearMarkers();
  this.map.addMarkers(
    stockists.map(function (result) {
      return {
        position: {
          lat: result.node.address.latitude,
          lng: result.node.address.longitude
        },
        title: result.node.name,
        address: {
          address1: result.node.address.address1,
          address2: result.node.address.address2,
          town: result.node.address.town,
          county: result.node.address.county
        }
      };
    })
  );
};

StockistFinder.prototype.closeStockistsList = function () {
  this.stockistsList.innerHTML = '';
  this.stockistsListHeader.classList.remove(this.classes.stockistsList.active);
};

StockistFinder.prototype.getResultElements = function () {
  return this.element.querySelectorAll('[data-stockist-finder-result]');
};

/** @param {Element} element */
StockistFinder.prototype.renderMap = function (element) {
  element = element || document.createElement('DIV');

  this.map = new GoogleMap(element);
};

StockistFinder.prototype.setInputValuesFromUrl = function () {
  var _this = this;

  this.optionalInputs.forEach(function (key) {
    var input = _this.element.elements[key];
    var queryValue = Route.param(key);
    if (queryValue && input) {
      input.value = queryValue;
    }
  });

  if (Route.param('postcode')) {
    this.element.postcode.value = Route.param('postcode');
    this.element.postcode.classList.add('is-filled');

    this.handleSubmit();
  }
};

window.onload = function () {
  var stockistFinder = document.querySelector('[data-stockist-finder-form]');
  if (stockistFinder) {
    window.stockistFinder = new StockistFinder(stockistFinder);
  }
};
